(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function toggleHeroVideo(wrap) {
      var section = wrap.closest('[id^="Hero-"]');
      if (!section) return;
      var btn = wrap.querySelector('.hero__video-play-pause');
      if (!btn) return;
      var targetId = btn.getAttribute('data-video-target');
      var video = section.querySelector('[data-testid="' + targetId + '"]');
      if (!video || video.tagName !== 'VIDEO') return;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      btn.setAttribute('data-paused', video.paused);
      btn.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    }

    function initHeroVideoControls(sectionEl) {
      if (!sectionEl) return;
      sectionEl.querySelectorAll('.hero__video-play-pause').forEach(function (btn) {
        var targetId = btn.getAttribute('data-video-target');
        var video = sectionEl.querySelector('[data-testid="' + targetId + '"]');
        if (!video || video.tagName !== 'VIDEO') return;
        function updateButton() {
          var paused = video.paused;
          btn.setAttribute('data-paused', paused);
          btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        }
        video.addEventListener('play', updateButton);
        video.addEventListener('pause', updateButton);
        updateButton();
      });
    }

    function setupClickDelegation() {
      document.addEventListener('click', function (e) {
        var wraps = document.querySelectorAll('.hero__video-play-pause-wrap');
        for (var i = 0; i < wraps.length; i++) {
          var r = wraps[i].getBoundingClientRect();
          if (r.width === 0 || r.height === 0) continue;
          if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
            e.preventDefault();
            e.stopPropagation();
            toggleHeroVideo(wraps[i]);
            return;
          }
        }
      }, true);
    }

    function init() {
      setupClickDelegation();
      document.querySelectorAll('[id^="Hero-"]').forEach(function (sectionEl) {
        initHeroVideoControls(sectionEl);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var sectionEl = e.detail.section || document.getElementById(e.detail.sectionId);
      if (sectionEl && sectionEl.querySelector('.hero__video-play-pause')) {
        initHeroVideoControls(sectionEl);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    const url = new URL(window.location.href);
    
    // Set availability filter to "in stock" by default if not already set
    const hasAvailabilityFilter = url.searchParams.has('filter.v.availability');
    
    if (!hasAvailabilityFilter) {
      // Update URL with the filter parameter (no redirect)
      url.searchParams.set('filter.v.availability', '1');
      history.replaceState({}, '', url.toString());
      
      // Defer filter initialization to avoid blocking initial render
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          function initializeAvailabilityFilter() {
            const facetsForm = document.querySelector('facets-form-component');
            if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
              facetsForm.updateFiltersByURL(url.toString());
            } else {
              setTimeout(initializeAvailabilityFilter, 100);
            }
          }
          initializeAvailabilityFilter();
        });
      });
      return;
    }
    
    // Handle hash scrolling - defer to avoid blocking paint
    if (url.hash) {
      requestAnimationFrame(() => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
